'use strict';

var React = require('react');
var Controlled = require('./Controlled.js');
var Uncontrolled = require('./Uncontrolled.js');
var Context = require('./Context.js');

/**
 * @description AB testing context provider component.
 *
 * @component
 * @example
 * ```jsx
 * <AbTestingProvider initialValue={****}>content</AbTestingProvider>
 * ```
 */
function AbTestingProvider(props) {
    const { mode = 'uncontrolled', children } = props;
    const isControlled = mode === 'controlled';
    if (isControlled) {
        const { value } = props;
        return React.createElement(Controlled.ControlledAbTestingProvider, { value: value }, children);
    }
    const { initialValue } = props;
    return React.createElement(Uncontrolled.UncontrolledAbTestingProvider, { initialValue: initialValue }, children);
}

exports.AbTestingContext = Context.AbTestingContext;
exports.AbTestingProvider = AbTestingProvider;
//# sourceMappingURL=index.js.map
